import Requisicao from "./RequisicaoService";

class ModalidadePagamentoService {
    static async listar() {
        return Requisicao.get('modalidade-pagamento');
    }    

    static async listarModalidadeParceladas() {
        return Requisicao.get('modalidade-pagamento/parceladas');
    } 
}

export default ModalidadePagamentoService;